// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/cool-bleiben-bei-heissen-temperaturen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const coolBleibenBeiHeissenTemperaturenDE: PageEntry = {
  id: "post.cool-bleiben-bei-heissen-temperaturen",
  locale: "de",
  slug: "cool-bleiben-bei-heissen-temperaturen",
  seo: {
    title: "Cool bleiben bei heißen Temperaturen und Sonne satt | Dietz GmbH",
    description: "Cool bleiben bei heißen Temperaturen und Sonne satt",
  },
  type: "post",
  h1: "Cool bleiben bei heißen Temperaturen und Sonne satt",
  blocks: [
    { kind: "heading", level: 2, text: "Cool bleiben bei heißen Temperaturen und Sonne satt" }
  ],
};
